import React from 'react'
import cn from 'classnames'
import Button from '@/components/Button'
import TutorText from './TutorText'
import { IPropsMainJeka } from '../interfaces'
import { zheka } from '@/images'

import style from '../styles/game.module.scss'
import { SHOW_STATUSES } from '../const'

const CLASS_POSTFIX = {
  0: 'first',
  1: 'second',
  2: 'last'
}

const MainJeka = ({
  showStatus = SHOW_STATUSES.hide,
  step = 0,
  chageTutorStep = () => {},
  hideTutor = () => {}
}: IPropsMainJeka): React.ReactElement | null => {
  const createImageElements = (): React.ReactElement[] => {
    const elements: React.ReactElement[] = []
    for (let i = 0; i < 3; i++) {
      const postfix: string = CLASS_POSTFIX[i]
      const elem = (
        <img
          key={`jeka-${postfix}`}
          src={zheka}
          className={cn({
            [style.jeka__img]: true,
            [style.stack__fragment]: true,
            [style[`stack__fragment_${postfix}`]]: true
          })}
        />
      )

      elements.push(elem)
    }
    return elements
  }

  const createTextElements = (): React.ReactElement[] => {
    const elements: React.ReactElement[] = []
    for (let i = 0; i < 3; i++) {
      const postfix: string = CLASS_POSTFIX[i]
      const elem = (
        <span
          key={`text-${postfix}`}
          className={cn({
            [style.stack__fragment]: true,
            [style[`stack__fragment_${postfix}`]]: true
          })}
        >
          <TutorText classPostfix={postfix} step={step} />
        </span>
      )

      elements.push(elem)
    }
    return elements
  }

  return (
    <div
      className={cn({
        [style.jeka__wrapper]: true,
        [style.fragment_close]: showStatus === SHOW_STATUSES.close,
        [style.jeka__wrapper_show]: showStatus === SHOW_STATUSES.show
      })}
    >
      <div
        className={cn({
          [style.stack]: true,
          [style.fragment_close]: showStatus === SHOW_STATUSES.close
        })}
      >
        {createImageElements().map(el => el)}
      </div>
      <div
        className={cn({
          [style.jeka__dialog]: true,
          [style.fragment_close]: showStatus === SHOW_STATUSES.close,
          [style.jeka__dialog_show]: showStatus === SHOW_STATUSES.show
        })}
      >
        <div
          className={cn({
            [style.jeka__text]: true,
            [style.fragment_close]: showStatus === SHOW_STATUSES.close,
            [style.stack]: true
          })}
        >
          {createTextElements().map(el => el)}
        </div>
        <div className={style.jeka__btns}>
          <Button
            className={cn({
              [style.jeka__btn]: true,
              [style.fragment_close]: showStatus === SHOW_STATUSES.close,
              [style.jeka__btn_show]: showStatus === SHOW_STATUSES.show
            })}
            outline
            onClick={hideTutor}
          >
            Закрыть
          </Button>
          {step < 7
            ? (
              <Button
                className={cn({
                  [style.jeka__btn]: true,
                  [style.fragment_close]: showStatus === SHOW_STATUSES.close,
                  [style.jeka__btn_show]: showStatus === SHOW_STATUSES.show
                })}
                onClick={chageTutorStep}
              >
                Продолжить
              </Button>
              )
            : null}
        </div>
      </div>
    </div>
  )
}

export default MainJeka
